import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { Tabs } from '../../components/ui/Tabs';
import { Button } from '../../components/ui/Button';
import { Avatar } from '../../components/ui/Avatar';
import { Drawer } from '../../components/ui/Drawer';
import { Badge } from '../../components/ui/Badge';
import { PlusIcon, PaperclipIcon, SendIcon, SearchIcon } from 'lucide-react';
const conversations = [{
  id: '1',
  sender: 'Rachel Tan',
  role: 'FPG Procurement',
  subject: 'PO-2026-00141 delivery schedule',
  preview: 'Can we expedite the delivery for line item 2?',
  time: 'Mar 12',
  unread: true
}, {
  id: '2',
  sender: 'Kevin Teo',
  role: 'FPG Pharmacy',
  subject: 'MedWell Q1 performance review',
  preview: 'Please find attached the Q1 performance scorecard.',
  time: 'Mar 10',
  unread: false
}, {
  id: '3',
  sender: 'System Notification',
  role: 'Portal',
  subject: 'Forecast Q2 2026 published',
  preview: 'The demand forecast for Q2 2026 is now available.',
  time: 'Mar 10',
  unread: false
}, {
  id: '4',
  sender: 'Michelle Wong',
  role: 'FPG Private Label',
  subject: 'Contract renewal discussion',
  preview: 'Let us schedule a call to discuss the upcoming renewal.',
  time: 'Mar 5',
  unread: false
}];
export const MessagesPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('inbox');
  const [selectedConv, setSelectedConv] = useState(conversations[0]);
  const [isNewMessageOpen, setIsNewMessageOpen] = useState(false);
  return <div className="max-w-7xl mx-auto h-[calc(100vh-8rem)] flex flex-col space-y-4" data-id="element-1302">
      <PageHeader title="Messages" breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Messages'
    }]} primaryAction={<Button leftIcon={<PlusIcon className="w-4 h-4" data-id="element-1305" />} onClick={() => setIsNewMessageOpen(true)} data-id="element-1304">
            New Message
          </Button>} data-id="element-1303" />
      <Card className="flex-1 flex overflow-hidden noPadding" data-id="element-1306">
        {/* Left Panel - List */}
        <div className="w-1/3 border-r border-border-light flex flex-col bg-surface-secondary" data-id="element-1307">
          <div className="p-4 border-b border-border-light bg-surface-primary" data-id="element-1308">
            <div className="relative" data-id="element-1309">
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-tertiary" data-id="element-1310" />
              <input type="text" placeholder="Search messages..." className="w-full pl-9 pr-4 py-2 text-sm border border-border-default rounded-fluent focus:outline-none focus:ring-2 focus:ring-fpg-navy" data-id="element-1311" />
            </div>
          </div>
          <div className="px-4 pt-2 bg-surface-primary border-b border-border-light" data-id="element-1312">
            <Tabs tabs={[{
            id: 'inbox',
            label: 'Inbox'
          }, {
            id: 'sent',
            label: 'Sent'
          }, {
            id: 'archived',
            label: 'Archived'
          }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-1313" />
          </div>
          <div className="flex-1 overflow-y-auto" data-id="element-1314">
            {conversations.map(conv => <div key={conv.id} onClick={() => setSelectedConv(conv)} className={`p-4 border-b border-border-light cursor-pointer transition-colors ${selectedConv.id === conv.id ? 'bg-white border-l-4 border-l-fpg-navy' : 'hover:bg-white border-l-4 border-l-transparent'}`} data-id="element-1315">
                <div className="flex justify-between items-start mb-1" data-id="element-1316">
                  <span className={`text-sm font-semibold ${conv.unread ? 'text-text-primary' : 'text-text-secondary'}`} data-id="element-1317">
                    {conv.sender}
                  </span>
                  <span className="text-xs text-text-tertiary" data-id="element-1318">
                    {conv.time}
                  </span>
                </div>
                <p className={`text-sm mb-1 truncate ${conv.unread ? 'font-medium text-text-primary' : 'text-text-secondary'}`} data-id="element-1319">
                  {conv.subject}
                </p>
                <p className="text-xs text-text-tertiary truncate" data-id="element-1320">
                  {conv.preview}
                </p>
              </div>)}
          </div>
        </div>
        {/* Right Panel - Thread */}
        <div className="flex-1 flex flex-col bg-surface-primary" data-id="element-1321">
          {selectedConv ? <>
              <div className="p-6 border-b border-border-light flex justify-between items-center" data-id="element-1322">
                <div data-id="element-1323">
                  <h2 className="text-lg font-semibold text-text-primary" data-id="element-1324">
                    {selectedConv.subject}
                  </h2>
                  <p className="text-sm text-text-secondary" data-id="element-1325">
                    Between you and {selectedConv.sender} ({selectedConv.role})
                  </p>
                </div>
                <Badge variant="info" data-id="element-1326">PO-2026-00141</Badge>
              </div>
              <div className="flex-1 overflow-y-auto p-6 space-y-6" data-id="element-1327">
                {/* Message Bubble */}
                <div className="flex gap-4" data-id="element-1328">
                  <Avatar initials={selectedConv.sender.substring(0, 2)} size="md" data-id="element-1329" />
                  <div className="flex-1" data-id="element-1330">
                    <div className="flex items-baseline gap-2 mb-1" data-id="element-1331">
                      <span className="font-semibold text-sm text-text-primary" data-id="element-1332">
                        {selectedConv.sender}
                      </span>
                      <span className="text-xs text-text-tertiary" data-id="element-1333">
                        {selectedConv.time}, 10:30 AM
                      </span>
                    </div>
                    <div className="bg-surface-secondary p-4 rounded-fluent-lg rounded-tl-none text-sm text-text-primary inline-block" data-id="element-1334">
                      <p data-id="element-1335">{selectedConv.preview}</p>
                      <p className="mt-2" data-id="element-1336">
                        Please let me know if this is possible. Thanks!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4 border-t border-border-light bg-surface-secondary" data-id="element-1337">
                <div className="bg-surface-primary border border-border-default rounded-fluent-lg p-2 focus-within:ring-2 focus-within:ring-fpg-navy" data-id="element-1338">
                  <textarea className="w-full p-2 text-sm focus:outline-none resize-none" rows={3} placeholder="Type your reply..." data-id="element-1339"></textarea>
                  <div className="flex justify-between items-center mt-2 px-2" data-id="element-1340">
                    <Button variant="ghost" size="sm" leftIcon={<PaperclipIcon className="w-4 h-4" data-id="element-1342" />} data-id="element-1341">
                      Attach
                    </Button>
                    <Button variant="primary" size="sm" rightIcon={<SendIcon className="w-4 h-4" data-id="element-1344" />} data-id="element-1343">
                      Send
                    </Button>
                  </div>
                </div>
              </div>
            </> : <div className="flex-1 flex items-center justify-center text-text-tertiary" data-id="element-1345">
              Select a conversation to view
            </div>}
        </div>
      </Card>
      <Drawer isOpen={isNewMessageOpen} onClose={() => setIsNewMessageOpen(false)} title="New Message" size="md" footer={<>
            <Button variant="ghost" onClick={() => setIsNewMessageOpen(false)} data-id="element-1347">
              Cancel
            </Button>
            <Button variant="primary" rightIcon={<SendIcon className="w-4 h-4" data-id="element-1349" />} data-id="element-1348">
              Send Message
            </Button>
          </>} data-id="element-1346">
        <div className="space-y-4" data-id="element-1350">
          <div data-id="element-1351">
            <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1352">
              To
            </label>
            <input type="text" className="w-full p-2 border border-border-default rounded-fluent text-sm" placeholder="Search FPG contacts..." data-id="element-1353" />
          </div>
          <div data-id="element-1354">
            <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1355">
              Subject
            </label>
            <input type="text" className="w-full p-2 border border-border-default rounded-fluent text-sm" placeholder="Message subject" data-id="element-1356" />
          </div>
          <div data-id="element-1357">
            <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1358">
              Related Object (Optional)
            </label>
            <input type="text" className="w-full p-2 border border-border-default rounded-fluent text-sm" placeholder="e.g., PO-2026-00142" data-id="element-1359" />
          </div>
          <div data-id="element-1360">
            <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1361">
              Message
            </label>
            <textarea className="w-full p-2 border border-border-default rounded-fluent text-sm" rows={6} placeholder="Type your message here..." data-id="element-1362"></textarea>
          </div>
          <Button variant="secondary" leftIcon={<PaperclipIcon className="w-4 h-4" data-id="element-1364" />} data-id="element-1363">
            Attach Files
          </Button>
        </div>
      </Drawer>
    </div>;
};